/* eslint-disable react/require-default-props */
import { Modal } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import React, { FC, useState } from 'react'
import CreditsProvider from '../providers/CreditsProvider'
import { TCreditType } from '../types'
import PurchaseCreditPlan from './PurchaseCreditPlan'

interface InsufficientCreditsProps {
 message?: string
 visible: boolean
 onCancel: () => void
 onSuccess?: () => void
 creditType?: TCreditType
}

const InsufficientCredits: FC<InsufficientCreditsProps> = ({
 visible,
 onCancel,
 onSuccess,
 creditType = 'sms',
 message = `You do not have enough ${creditType} credits. Please purchase additional credits to continue.`,
}) => {
 const [showPurchasePlan, setShowPurchasePlan] = useState(false)

 return (
  <CreditsProvider type={creditType}>
   <Modal
    visible={visible && !showPurchasePlan}
    onCancel={onCancel}
    footer={null}
    width={400}
    closeIcon={false}
    centered
   >
    <div className="d-flex flex-column align-items-center justify-content-center text-center">
     <div className="mb-3">
      <i
       className="fas fa-exclamation-circle text-warning"
       style={{ fontSize: '3rem', color: '#faad14' }}
      />
     </div>
     <h3 className="mb-2">Insufficient Credits</h3>
     <p className="mb-4">{message}</p>
     <div
      className="d-flex justify-content-center w-100"
      style={{ gap: '10px' }}
     >
      <BaseButton onClick={onCancel}>Cancel</BaseButton>
      <BaseButton
       buttonType="primary"
       onClick={() => setShowPurchasePlan(true)}
      >
       Buy Credits
      </BaseButton>
     </div>
    </div>
   </Modal>

   {showPurchasePlan && (
    <PurchaseCreditPlan
     visible={showPurchasePlan}
     onCancel={() => {
      setShowPurchasePlan(false)
     }}
     onSuccuss={() => {
      setShowPurchasePlan(false)
      onSuccess?.()
      onCancel()
     }}
    />
   )}
  </CreditsProvider>
 )
}

export default InsufficientCredits
